<app-envelope-list [searchValue]="filter.textSearch" [sortOptions]="sortOptions"
    [selectedSortOption]="selectedSortOption" title="{{ 'menu.sent' | translate | titlecase }}"
    [sortOnboardingReady]="sortOnboardingReady"
    (onChangeType)="onChangeType($event)" (checkAllClick)="onCheckAllClick($event)"
    (searchValueChange)="onSearchValueChange($event)"
    (sortChange)="onSortChange($event)" (filterChange)="onFilterChange($event)"
    (filterClear)="onFilterClear($event)"
    (filterButtonClick)="onFilterButtonClick()">
    <app-sent-tabs tabs [statusCounter]="statusCounter" (onChangeTab)="onTabChange($event)" (onTabClick)="onTabClick($event)"></app-sent-tabs>
    <app-sent-list list *ngIf="(envelopeStructure?.list.length > 0); else blankSlateSent"
        [envelopeStructure]="envelopeStructure" (showEnvelopeDetails)="onShowEnvelopeDetails($event)">
    </app-sent-list>
    <app-sent-detail-sidebar 
        details-sidebar [envelopeId]="detailedEnvelopeId" 
        [envelopeStatus]="filter.status"
        (discardEnvelope)="onDiscardEnvelope()" 
        (updateCardEnvelope)="onUpdateCardEnvelope($event)">
    </app-sent-detail-sidebar>
</app-envelope-list>

<ng-template #blankSlateSent>
    <cdx-blankslate [options]="blankslateOptions" (buttonClick)="onBlankSlateButtonClick($event)">
        {{ 'envelope.sent.list.noEnvelopeFounded' | translate }} </cdx-blankslate>
</ng-template>
